// src/i18n.js

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Uygulamanın tek dili Türkçedir.
import tr from './locales/tr/translation.json'

const resources = {
  tr: { translation: tr }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'tr',
    supportedLngs: ['tr'],
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
